import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { forkJoin } from 'rxjs/index';
import { GenericFilter } from '../model/filter/genericFilter.model';
import { BusinessProcess } from '../model/filter/businessProcess.model';
import { State } from '../model/filter/state.model';
import { User } from '../model/user/user.model';
import { BusinessProcessListResult } from '../model/filter/businessProcesseListResult.model';
import { UserListResult } from '../model/filter/userListResult.model';
import { StateListResult } from '../model/filter/stateListResult.model';
import { ListPanelConfigurationUserQueueStatusResult } from '../model/configuration/listPanelConfigurationUserQueueStatusResult.model';
import { PanelConfigurationInstanceQueueStatusMetadata } from '../model/configuration/panelConfigurationInstanceQueueStatusMetadata.model';
import { FilterService } from '../services/filter/filter.service';
import { ConfigurationService } from '../services/configuration/configuration.service';
import { Grouping } from '../model/filter/grouping.model';
import { GroupingListResult } from '../model/filter/groupingListResult.model';
import { ToastrService } from 'ngx-toastr';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import {BehaviorSubject} from 'rxjs';

declare var $: any;

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.css']
})

export class FiltersComponent implements OnInit {

  @Output() filterEvent = new EventEmitter<GenericFilter>();
  @Output() cleanFilter = new EventEmitter();
  @Input() receiveFilterType;
  @Input() collapsed$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  SearchRecycle: boolean;

  errorUser = false;
  errorUserMessage: string;

  errorGrouping = false;
  errorGroupingMessage: string;

  errorState = false;
  errorStateMessage: string;

  errorBP = false;
  errorBPMessage: string;

  businessProcessList: Array<BusinessProcess> = [];
  userLists: Array<User> = [];
  filteredStates: Array<State> = [];
  groupingLists: Array<Grouping> = [];
  metadataColumns: Array<PanelConfigurationInstanceQueueStatusMetadata> = [];

  userListSelected: string;
  bPListSelected: string;
  filteredStatesSelected: string;
  groupingListSelected: string;

  bsRangeValue: Date[];
  bsValue = new Date();
  maxDate = new Date();

  groupingSplit: boolean;
  calulateType: number;

  filterRow1 = false;
  filterRow2 = false;
  filterRow3 = false;
  filterRowCustom1 = false;

  filter: GenericFilter;


  constructor(private filterService: FilterService
              , private configurationService: ConfigurationService
              , private localeService: BsLocaleService
              , private toastr: ToastrService) {

    this.filter = new GenericFilter();


    this.maxDate.setDate(this.maxDate.getDate() + 3);
    this.maxDate.setHours(23, 59, 59, 59);
    this.bsValue.setHours(0, 0, 0, 0);

    this.bsRangeValue = [this.bsValue, this.maxDate];

    localeService.use('pt-br');
  }

  // Reactive forms
  userCtrl = new FormControl();
  businessProcessCtrl = new FormControl();
  stateCtrl = new FormControl();
  groupingCtrl = new FormControl();

  formUser = new FormGroup({
    userList: this.userCtrl
  });

  formBusinessProcess = new FormGroup({
    businessProcessList: this.businessProcessCtrl
  });

  formState = new FormGroup({
    stateList: this.stateCtrl
  });

  formGrouping = new FormGroup({
    groupingList: this.groupingCtrl
  });

  ngOnInit() {

    this.processFilterType();
    this.getBusinessProcessAndUsers();
    this.getGrouping();
    this.onClickCleanFilter();

    if (this.collapsed$) {
      this.collapsed$.subscribe(val => {
        if (val) {
          $('#filtro-card-id').CardWidget('collapse');
        } else {
          $('#filtro-card-id').CardWidget('expand');
        }
      });
    }

  }

  processFilterType() {

    switch (this.receiveFilterType) {
      case (1):

        this.filterRow1 = true;
        this.filterRow2 = true;
        this.filterRow3 = true;

        break;
      case (2):

        this.filterRowCustom1 = true;
        this.filterRow2 = true;

        break;
      case (3):

        this.filterRow2 = true;

        break;
      case (4):

        this.filterRow2 = true;

        break;
    }
  }

  public getBusinessProcessAndUsers() {
    const getBusinessProcessCall = this.filterService.getBusinessProcess();
    const getUsersCall = this.filterService.getUsers();

    forkJoin([getBusinessProcessCall, getUsersCall]).subscribe(results => {
      const resultBPs: BusinessProcessListResult = results[0] as BusinessProcessListResult;
      const resultUsers: UserListResult = results[1] as UserListResult;

      if (resultBPs.result) {

        this.businessProcessList = resultBPs.result;
      }
      if (resultUsers.result) {

        this.userLists = resultUsers.result;
      }

      this.filter.User = undefined;
      this.filter.BusinessProcess = undefined;
    });
  }

  public getGrouping() {
    this.configurationService.listGroupingConfigurations().subscribe(
      (resp: GroupingListResult) => {
        if (resp.result) {
           this.groupingLists = resp.result;
        }
      }
    );
  }

  public getReportConfiguration() {
    this.configurationService.listPanelConfigurationUserQueueStatus().subscribe(
      (resp: ListPanelConfigurationUserQueueStatusResult) => {
        if (resp.result) {
          this.metadataColumns = resp.result;
        }
      });
  }

  onClickSendFilter() {

    this.filter.CalulateType = this.calulateType;

    if (this.bsRangeValue !== undefined) {
      this.filter.PeriodFrom = this.bsRangeValue[0].toISOString();
      this.filter.PeriodTo = this.bsRangeValue[1].toISOString();
    }

    this.filterEvent.emit(this.filter);
  }

  onClickCleanFilter() {

    this.filter = new GenericFilter();

    this.userListSelected = '';
    this.bPListSelected = '';
    this.filteredStatesSelected = '';
    this.groupingListSelected = '';
    this.groupingSplit = false;
    this.calulateType = 2;

    this.cleanFilter.emit();

  }

  onSelectUser(event: TypeaheadMatch): void {

    this.filter.User = event.item;
  }

  onSelectBP(event: TypeaheadMatch): void {

    this.filter.BusinessProcess = event.item;
  }

  onSelectState(event: TypeaheadMatch): void {

    this.filter.State = event.item;
  }

  onChangeBusinessProcess(e: TypeaheadMatch): void {

    if (this.filter.BusinessProcess !== undefined) {
      this.filterService.getStates(this.filter.BusinessProcess.businessProcessId).subscribe((resp: StateListResult) => {
        if (resp.result) {

          this.filteredStates = resp.result;
        }
      });
    }
  }

  onSelectGrouping(event: TypeaheadMatch): void {

    this.filter.Grouping = event.item;
  }

  removeUserListSelected() {
    this.userListSelected = undefined;
    this.errorUser = true;
    this.filter.User = new User();
  }

  removeBPListSelected() {
    this.bPListSelected = '';
    this.errorBP = false;
    this.filter.BusinessProcess = new BusinessProcess();

    this.removeStateListSelected();
  }

  removeStateListSelected() {
    this.filteredStatesSelected = '';
    this.errorState = false;
    this.filter.State = new State();
  }

  removeGroupingListSelected() {
    this.groupingListSelected = '';
    this.errorGrouping = false;
    this.filter.Grouping = new Grouping();
  }

  typeaheadNoResultsState(event: boolean): void {
    this.errorState = event;
    this.errorStateMessage = 'Nenhum resultado encontrado';
  }

  typeaheadNoResultsBP(event: boolean): void {
    this.errorBP = event;
    this.errorBPMessage = 'Nenhum resultado encontrado';

    this.removeStateListSelected();
  }

  typeaheadNoResultsGrouping(event: boolean): void {
    this.errorGrouping = event;
    this.errorGroupingMessage = 'Nenhum resultado encontrado';
  }

  typeaheadNoResultsUser(event: boolean): void {
    this.errorUser = event;
    this.errorUserMessage = 'Nenhum resultado encontrado';
  }
}
